import type {SwitchProps} from 'react-native';

export function Switch(props: SwitchProps) {
  return (
    <input
      type="checkbox"
      defaultChecked={props.value}
      disabled={props.disabled}
      onChange={(e) => props.onValueChange(e.target.checked)}
    />
  )
}
